import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import SvgIcon from 'src/react_components/svg-icon';

type RequiredNotCitedPanelProps = {
  count: number,
  node: HTMLDivElement
}

const RequiredNotCitedPanel: React.FC<RequiredNotCitedPanelProps> = ({ count, node }) => {
  const infoIcon = useRef<SVGSVGElement>(null);

  useEffect(() => {
    let popover = window.bootstrap.Popover.getInstance(infoIcon.current);
    if (popover) {
      popover.dispose();
      // workaround for https://github.com/twbs/bootstrap/issues/37474
      // @ts-ignore: We're messing with BS internals, but rather than polluting the type, we'll just ignore
      popover._activeTrigger = {};
      // @ts-ignore
      popover._element = document.createElement('noscript');
    }

    popover = new window.bootstrap.Popover(infoIcon.current, {
      content:
        'You need to categorise any uncited text matches as Not Cited or, ' +
        'if the minimum requirement cannot be met, categorise all remaining text matches appropriately.',
      trigger: 'hover',
      placement: 'bottom',
      container: 'body'
    });

    return () => {
      if (popover) {
        popover.dispose();
        // workaround for https://github.com/twbs/bootstrap/issues/37474
        // @ts-ignore: We're messing with BS internals, but rather than polluting the type, we'll just ignore
        popover._activeTrigger = {};
        // @ts-ignore
        popover._element = document.createElement('noscript');
      }
    };
  }, []);

  const countClass = count === 0 ? 'text-green' : 'text-danger';

  return createPortal(
    <div className="RequiredNotCitedPanel">
      <h4>Citation Assist</h4>
      <span className={countClass}><strong>{count}</strong></span>
      {' '}
      <b>not cited</b>
      {` text match categorisation${count !== 1 ? 's' : ''} `}
      left &nbsp;
      <SvgIcon icon="info_outline" ref={infoIcon} className="icon-sm" />
    </div>,
    node
  );
};

export default RequiredNotCitedPanel;
